import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useLazyLogoutQuery } from '../../redux/api/authApi';
import { useMyOrdersQuery } from '../../redux/api/bookingApi';
import { STATUS } from './rideConfig';
import '../../css/ride.css';

export default function RideAccount() {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useSelector((s) => s.auth);
  const [logout] = useLazyLogoutQuery();
  const { data } = useMyOrdersQuery(undefined, { skip: !isAuthenticated });
  const orders = data?.orders || [];
  const completed = orders.filter((o) => o.orderStatus === STATUS.COMPLETED).length;

  const logoutHandler = async () => {
    await logout();
    navigate('/ride');
  };

  const menu = [
    { icon: 'bi-journal-text', label: 'My rides', to: '/ride/rides' },
    { icon: 'bi-person-gear', label: 'Edit profile', to: '/me/update_profile' },
    { icon: 'bi-key', label: 'Change password', to: '/me/update_password' },
    { icon: 'bi-cash-stack', label: 'Payment method', text: 'Cash on delivery' },
    { icon: 'bi-shield-check', label: 'Privacy policy', to: '/privacy-policy' },
    { icon: 'bi-file-earmark-text', label: 'Terms & agreement', to: '/Terms-And-Agreement' },
  ];

  return (
    <>
      <div className="ride-topbar">
        <button className="ride-icon-btn" onClick={() => navigate(-1)} aria-label="Back">
          <i className="bi bi-chevron-left" />
        </button>
        <div className="ride-brand-pill"><span>Account</span></div>
        <span style={{ width: 44 }} />
      </div>

      <div className="ride-panel" style={{ background: 'var(--color-bg)' }}>
        <div className="ride-panel-inner">
          <div className="ride-account-hero">
            <img src={user?.avatar?.url || '/images/default_avatar.jpg'} alt="" />
            <div style={{ minWidth: 0 }}>
              <div className="hero-name">{user?.name || 'Guest'}</div>
              <div className="hero-sub">{user?.email || 'Sign in to sync your rides'}</div>
            </div>
          </div>

          <div className="ride-hero-stats">
            <div className="ride-hero-stat"><div className="num">{orders.length}</div><div className="lbl">Rides</div></div>
            <div className="ride-hero-stat"><div className="num">{completed}</div><div className="lbl">Completed</div></div>
            <div className="ride-hero-stat"><div className="num">{user?.isVerified ? '✓' : '—'}</div><div className="lbl">Verified</div></div>
          </div>

          <div className="ride-menu-card mt-4">
            {menu.map((m) =>
              m.to ? (
                <Link key={m.label} to={m.to} className="ride-rowlink" style={{ textDecoration: 'none' }}>
                  <span className="ride-row-ico"><i className={`bi ${m.icon}`} /></span>
                  <span className="ride-row-main"><div className="ride-row-title">{m.label}</div></span>
                  <i className="bi bi-chevron-right chev" />
                </Link>
              ) : (
                <div key={m.label} className="ride-rowlink">
                  <span className="ride-row-ico"><i className={`bi ${m.icon}`} /></span>
                  <span className="ride-row-main">
                    <div className="ride-row-title">{m.label}</div>
                    <div className="ride-row-sub">{m.text}</div>
                  </span>
                </div>
              )
            )}
          </div>

          {!isAuthenticated ? (
            <div className="d-grid gap-2 mt-4">
              <Link to="/login" className="ride-cta" style={{ textDecoration: 'none' }}>Sign in</Link>
              <Link to="/register" className="ride-cta ghost" style={{ textDecoration: 'none' }}>Create an account</Link>
            </div>
          ) : (
            <button className="ride-cta danger-ghost mt-4" onClick={logoutHandler}>
              <i className="bi bi-box-arrow-right" /> Log out
            </button>
          )}
        </div>
      </div>
    </>
  );
}
